import { PropsWithChildren } from "react";
import clsx from "clsx";

type SectionButtonProps = PropsWithChildren<{
  disabled: boolean;
  active: boolean;
  onClick: () => void;
}>;

export function SectionButton({ disabled, active, onClick, children }: SectionButtonProps) {
  return (
    <button
      className={clsx("text-xs font-medium px-2 py-1.5 rounded-lg whitespace-nowrap", {
        "bg-background-button-tertiary-hover text-text-base-secondary": active,
        "hover:bg-background-button-tertiary text-text-base-secondary": !disabled && !active,
        "text-text-base-primary-disabled cursor-not-allowed": disabled && !active,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
